// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Video zur Übung direkt in der App (Thors Wunsch Runde 13).
// Zwei Stufen, bewusst so gebaut:
//  - YouTube-Links laufen über youtube-nocookie.com und werden ERST auf Klick
//    geladen. Vorher geht kein einziger Aufruf zu Google — die Vorschau ist
//    unsere eigene Fläche. Deshalb steht in der CSP nur diese eine Domain.
//  - Alles andere (Vimeo, eigener Server, Webseite) bleibt ein Link, weil
//    fremde Seiten nicht in unsere App eingebettet werden dürfen.
import { useState } from "react"
import { sichereUrl } from "@/lib/video"
import { IconVideo } from "@/components/icons"

/** YouTube-Id aus watch?v=, youtu.be/, /shorts/ oder /embed/ — sonst null. */
export function youtubeId(url: string | undefined): string | null {
  const sicher = sichereUrl(url)
  if (!sicher) return null
  try {
    const u = new URL(sicher)
    const host = u.hostname.replace(/^www\./, "")
    if (host === "youtu.be") return u.pathname.slice(1).split("/")[0] || null
    if (host !== "youtube.com" && host !== "m.youtube.com" && host !== "youtube-nocookie.com") return null
    const v = u.searchParams.get("v")
    if (v) return v
    const m = u.pathname.match(/^\/(?:embed|shorts|v)\/([^/?#]+)/)
    return m ? m[1] : null
  } catch {
    return null
  }
}

export default function VideoPanel({ url, titel }: { url: string; titel: string }) {
  const [laeuft, setLaeuft] = useState(false)
  const id = youtubeId(url)
  const sicher = sichereUrl(url)
  if (!sicher) return null

  // Kein YouTube → schlichter Link, fremde Seiten kommen nicht in die App
  if (!id) {
    return (
      <a className="video-link" href={sicher} target="_blank" rel="noreferrer">
        <IconVideo size={18} /> Video öffnen ↗
      </a>
    )
  }

  if (!laeuft) {
    return (
      <button type="button" className="video-vorschau" onClick={() => setLaeuft(true)}>
        <span className="video-play" aria-hidden="true">▶</span>
        <span className="video-txt">
          <b>Video ansehen</b>
          <small>Wird erst beim Antippen von YouTube geladen</small>
        </span>
      </button>
    )
  }

  return (
    <div className="video-rahmen">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`}
        title={`Video: ${titel}`}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  )
}
